export { SELECTION_CHANGE, SelectionDirection, SelectionMode } from '@fluentui/utilities';
//# sourceMappingURL=interfaces.js.map